<template>
	<div>
		<case-form :schema="schema" />
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"

export default {
	name: "JBProposalSendings",
	components: { CaseForm },
	data() {
		return {
			schema: [
				{
					component: "html",
					props: {
						content:
							"<div class='fs4 fw7 lh125'>8. (IV) What was the AGGREGATE TOTAL value of all insured property sent during the past 12 months:</div>"
					},
					bindTo: ""
				},
				{
					component: "html",
					props: {
						content:
							"<div class='fs4 fw7 lh125'>(a) in the country in which the Proposer's premises are situated?</div>"
					},
					bindTo: ""
				},
				{
					label: "By Registered Post",
					component: "text",
					bindTo: "case.facts.aggregateValueInCountryRegisteredPost"
				},
				{
					label: "By Registered Air Mail",
					component: "text",
					bindTo: "case.facts.aggregateValueInCountryRegisteredAirMail"
				},
				{
					label: "By Other Air Conveyances",
					component: "text",
					bindTo: "case.facts.aggregateValueInCountryOtherAirConveyances"
				},
				{
					label: "By Ordinary Post, Rail, Steamer and other Conveyances",
					component: "text",
					bindTo: "case.facts.aggregateValueInCountryOrdinaryPost"
				},
				{
					component: "html",
					props: {
						content:
							"<div class='fs4 fw7 lh125'>(b) elsewhere (state countries and values sent to each)?</div>"
					},
					bindTo: ""
				},
				{
					label: "By Registered Post",
					component: "longText",
					bindTo: "case.facts.aggregateValueElsewhereRegisteredPost"
				},
				{
					label: "By Registered Air Mail",
					component: "longText",
					bindTo: "case.facts.aggregateValueElsewhereRegisteredAirMail"
				},
				{
					label: "By Other Air Conveyances",
					component: "longText",
					bindTo: "case.facts.aggregateValueElsewhereOtherAirConveyances"
				},
				{
					label: "By Ordinary Post, Rail, Steamer and other Conveyances",
					component: "longText",
					bindTo: "case.facts.aggregateValueElsewhereOrdinaryPost"
				}
			]
		}
	}
}
</script>
